import { appConfigStore } from 'Models/AppConfigStore';
import * as React from 'react';
import { BookingDetailSection, SectionProps } from '../../SharedSections/BookingDetailSection';
import { stringNotEmpty } from 'Util/TypeGuards';
import { useIntl } from 'react-intl';

export function AdditionalNotesInfoSection({ booking, canEdit, onEdit, isInvoiced }: SectionProps) {
	const intl = useIntl();

	if (!(appConfigStore.bookingNoteEnabled && stringNotEmpty(booking.bookedSummary?.note))) {
		return null;
	}
	if (!booking.bookedSummary) {
		console.error('Booked summary missing, this should not happen');
		return <></>;
	}

	const sectionContent = <p className="booking-additional-notes">{booking.bookedSummary.note ?? '-'}</p>;

	return (
		<BookingDetailSection
			sectionName={
				booking.hasVehicle()
					? intl.formatMessage({
							id: 'vehicle-tab__additional-information__label',
							defaultMessage: 'Additional notes',
						})
					: intl.formatMessage({
							id: 'passenger-booking__additional-information__label',
							defaultMessage: 'Additional notes',
						})
			}
			sectionContent={sectionContent}
			sectionClassName="notes"
			icon={{
				name: 'sticky_note_2',
				useMaterialIcons: true,
			}}
			modificationRules={{
				canEdit: canEdit,
				editType: booking.hasVehicle() ? 'vehicle' : 'add-on',
				onEdit: onEdit,
				isInvoiced: isInvoiced,
			}}
		/>
	);
}
